import React from 'react';

const Header = () => (
    <>
        <div className="progress-wrap cursor-pointer">
            <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
            </svg>
        </div>
        <nav className="navbar navbar-expand-lg" role="navigation">
            <div className="container">

                {/* Logo */}
                <div className="logo-wrapper">

                    <a
                        className="logo"
                        href="/"
                        aria-label="Residency Group Hotels Home"
                    >

                        <img
                            src="img/logo.webp"
                            className="logo-img img-fluid"
                            alt="Residency Group Hotels Logo"
                            width="180"
                            height="70"
                            decoding="async"
                        />

                    </a>

                </div>

                {/* Mobile Menu Button */}
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbar"
                    aria-controls="navbar"
                    aria-expanded="false"
                    aria-label="Toggle navigation menu"
                >
                    <span className="navbar-toggler-icon">
                        <i className="ti-menu" aria-hidden="true"></i>
                    </span>
                </button>

                {/* Navbar */}
                <div className="collapse navbar-collapse" id="navbar">

                    <ul className="navbar-nav ms-auto">

                        <li className="nav-item">
                            <a
                                className="nav-link"
                                href="/"
                                aria-label="Home Page"
                            >
                                Home
                            </a>
                        </li>

                        <li className="nav-item">
                            <a
                                className="nav-link"
                                href="/about-us"
                                aria-label="About Us Page"
                            >
                                About Us
                            </a>
                        </li>

                        <li className="nav-item">
                            <a
                                className="nav-link"
                                href="/hotels"
                                aria-label="Hotels Page"
                            >
                                Hotels
                            </a>
                        </li>

                        <li className="nav-item">
                            <a
                                className="nav-link"
                                href="/events"
                                aria-label="Events Page"
                            >
                                Events
                            </a>
                        </li>

                        <li className="nav-item">
                            <a
                                className="nav-link BookNow"
                                href="/contact-us"
                                aria-label="Contact Us Page"
                            >
                                Contact Us
                            </a>
                        </li>

                    </ul>

                </div>
            </div>
        </nav>
       
    </>
);

export default Header;